/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React, {type ReactNode} from 'react'
import clsx from "clsx";

interface UiRoundedContentProps {
    className?: string
    children?: ReactNode
}

const UiRoundedContent = (props: UiRoundedContentProps) => {
    return (
        <div
            className={clsx(
                'UiRoundedContent',
                props.className,
                'rounded-2xl border border-slate-200 dark:border-slate-700 overflow-hidden'
            )}
        >
            {props.children}
        </div>
    )
}

export default UiRoundedContent
